///*eslint-disable jsx-a11y/no-noninteractive-tabindex */
///*eslint-disable jsx-a11y/no-redundant-roles */
///*eslint-disable jsx-a11y/no-noninteractive-element-interactions */
///*eslint-disable jsx-a11y/click-events-have-key-events */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
/*eslint-disable no-dupe-else-if */
import React, { useMemo, useState, useEffect } from 'react';
import { useTable, useSortBy, usePagination, useRowSelect } from 'react-table';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import Checkbox from '../../common/Checkbox';
import ButtonWithMenu from '../../common/ButtonWithMenu';
import {
  CompletedIcon,
  FailedIcon,
  WarningIcon,
} from 'src/Admin/img/Reports/ReportsSvgImages';
import { OverlayTrigger, Popover, Row, Col } from 'react-bootstrap';
import {
  CustomPagination,
  CustomPaginationItemsDisplay,
} from '../../common/CustomPagination';
import useReportList from '../hooks/useReportList';
import useDate from 'src/Admin/utils/useDate';
import ReportsTableSkeleton from '../Skeleton/ReportsTableSkeleton';

const ReportsListTable = ({
  columns,
  data = [],
  pageSizeCount,
  labelProp = 'Reports List',
}) => {
  const {
    handleSelectionReport,
    handleDownloadReport,
    paginationHandler,
    pageSizeHandler,
    resetReportFilters,
    isDataFetching,
    isServerErrorOnList,
    isServerDataNotFoundErrorOnList,
    reportsData,
  } = useReportList();
  const { formatDate } = useDate();
  const [isLoading, setIsLoading] = useState(false);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageSize },
    gotoPage,
    setPageSize,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: pageSizeCount,
        sortBy: [
          {
            id: 'createdDate',
            desc: true,
          },
        ],
      },
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: 'selection',
            sortable: false,
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <Checkbox
                className="d-none"
                {...getToggleAllRowsSelectedProps()}
              />
            ),
            Cell: ({ row }) => (
              <Checkbox
                className="d-none"
                isDisabled={row?.original?.status === 'In Progress'}
                {...row?.getToggleRowSelectedProps()}
              />
            ),
          },
          ...columns,
        ];
      });
    },
  );

  const onClick = (ele) => {
    if (ele) {
      console.log(ele, 'PageRedirect');
    }
  };

  const showingRecordsMessage = () => {
    let message = '';
    message = `Showing ${
      reportsData?.pagination?.pageNumber * reportsData?.pagination?.pageSize -
      reportsData?.pagination?.pageSize +
      1
    } - ${
      reportsData?.pagination?.pageSize *
        (reportsData?.pagination?.pageNumber + 1) <
      reportsData?.pagination?.totalRecords
        ? reportsData?.pagination?.pageSize *
          reportsData?.pagination?.pageNumber
        : reportsData?.pagination?.totalRecords
    } of ${reportsData?.pagination?.totalRecords} results`;
    return message;
  };

  useEffect(() => {
    const filteredDataWithStatus = selectedFlatRows.filter(
      (row) => row?.original?.status !== 'In Progress',
    );
    handleSelectionReport(
      filteredDataWithStatus?.map((item) => item?.original),
    );
  }, [selectedFlatRows]);

  useEffect(() => {
    resetReportFilters();
  }, []);

  useMemo(() => {
    setPageSize(pageSizeCount);
  }, [pageSizeCount]);

  const download_buttons = [
    { label: 'DOWNLOAD PDF', fileType: 'pdf' },
    { label: 'DOWNLOAD EXCEL', fileType: 'xls' },
  ];

  const tableCellDataHandler = (cell, index) => {
    if (index === 5) {
      return (
        <>
          {cell?.row?.original?.status === 'Completed' ? (
            <ButtonWithMenu
              options={download_buttons}
              title="DOWNLOAD PDF"
              itemAction={(item) =>
                handleDownloadReport(cell?.row?.original, item.fileType)
              }
              onClick={() => {
                handleDownloadReport(
                  cell?.row?.original,
                  download_buttons[0].fileType,
                );
              }}
            />
          ) : (
            <span className="not-ready-text">Not Yet Ready</span>
          )}
        </>
      );
    } else if (cell?.row?.original?.status === 'Failed' && index === 4) {
      return (
        <span className="d-flex h-100 align-items-center">
          <span className="mr-2">Failed</span>
          <OverlayTrigger
            placement="top"
            delay={{ show: 200, hide: 450 }}
            overlay={
              <Popover className="reports-tooltip-container">
                <Popover.Content>
                  <div className="tooltip-content-container">
                    <span>
                      <WarningIcon />
                    </span>
                    <span className="reports-tooltip-text">
                      {cell?.row?.original?.reasonOfFailing}
                    </span>
                  </div>
                </Popover.Content>
              </Popover>
            }
          >
            <span>
              <FailedIcon className="failed-icon" />{' '}
            </span>
          </OverlayTrigger>
        </span>
      );
    } else if (cell?.row?.original?.status === 'Completed' && index === 4) {
      return (
        <span className="d-flex h-100 align-items-center">
          <span className="mr-2">Completed</span>
        </span>
      );
    } else if (index === 3) {
      return formatDate(cell?.row?.original?.createdDate);
    } else if (index === 1) {
      return <div className="report-name-cell">{cell.render('Cell')}</div>;
    } else {
      return cell.render('Cell');
    }
  };

  //Render the UI for your table
  return (
    <>
      <div className="reports-list-table-admin">
        {isDataFetching ? (
          <ReportsTableSkeleton />
        ) : (
          <div>
            <Row className="mt-4 mb-4 align-items-center">
              {reportsData?.pagination?.totalRecords > 10 && (
                <>
                  <Col sm={6}>
                    <CustomPaginationItemsDisplay
                      pageSize={reportsData?.pagination?.pageSize}
                      setPageSize={(e) => pageSizeHandler(Number(e?.value))}
                      prefixMessage="Records per page"
                      suffixMessage={showingRecordsMessage()}
                    />
                  </Col>
                  <Col sm={6} className="text-right mt-4 mt-md-0">
                    <div className="reports-table-pagination">
                      {reportsData?.pagination?.totalRecords > 10 ? (
                        <CustomPagination
                          pageSize={reportsData?.pagination?.pageSize}
                          currentPage={reportsData?.pagination?.pageNumber}
                          totalCount={reportsData?.pagination?.totalRecords}
                          onPageChange={(page) => {
                            paginationHandler(page);
                            //dispatch( setSearchParams( {pageNumber: page} ) );
                            //recordsFilterHandler( recordsToDisplay, pageSize, page );
                          }}
                        />
                      ) : null}
                    </div>
                  </Col>
                </>
              )}
            </Row>
            {!isServerErrorOnList && (
              <table
                className="table padding-mobile-0"
                {...getTableProps()}
                aria-rowcount={data?.length}
                onBlur={() => setIsLoading(true)}
              >
                <caption className="sr-only">{labelProp}</caption>
                {data?.length > 0 && (
                  <thead>
                    {headerGroups.map((headerGroup, index) => (
                      <tr
                        key={index}
                        {...headerGroup.getHeaderGroupProps()}
                        role="row"
                      >
                        {headerGroup.headers.map((column) => (
                          <th
                            key={index}
                            {...column.getHeaderProps(
                              column.getSortByToggleProps({ title: undefined }),
                            )}
                            scope="col"
                            role="columnheader"
                            onKeyPress={(event) => {
                              if (
                                column.sortable !== false &&
                                event.key === 'Enter'
                              ) {
                                column.toggleSortBy();
                              }
                            }}
                            className={
                              column.isSorted
                                ? 'coloumnIsSorted'
                                : 'coloumnNotSorted'
                            }
                          >
                            <span
                              className={`${
                                column.render('Header') === 'Report Name'
                                  ? 'w-25'
                                  : ''
                              }`}
                            >
                              {column.render('Header')}
                            </span>
                            {column?.sortable !== false && (
                              <span
                                className={
                                  column.isSorted
                                    ? column.isSortedDesc
                                      ? 'arrowDown'
                                      : 'arrowUp'
                                    : 'arrowNormal'
                                }
                                tabIndex={0}
                                aria-label={
                                  column.isSorted
                                    ? column.isSortedDesc
                                      ? ` ${column.Header} sorted descending`
                                      : ` ${column.Header} sorted ascending`
                                    : ` ${column.Header} sorted none`
                                }
                                aria-live="polite"
                                aria-atomic={isLoading}
                                aria-sort={
                                  column.isSorted
                                    ? column.isSortedDesc
                                      ? 'descending'
                                      : 'ascending'
                                    : 'none'
                                }
                              ></span>
                            )}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                )}
                <tbody {...getTableBodyProps()} role="rowgroup">
                  {page.map((row, index) => {
                    prepareRow(row);
                    return (
                      <tr key={index} {...row.getRowProps()}>
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              role="cell"
                              onClick={() =>
                                index === 0 ? onClick(row) : null
                              }
                            >
                              <p className="reports-table-cell-data-admin">
                                {tableCellDataHandler(cell, index)}
                                {/*(cell?.row?.original?.status === "Failed" && index === 5) ? (<div className='d-flex h-100 align-items-center'><span className='mr-2'>Failed</span><FailedIcon /></div>) : (cell?.row?.original?.status === "Completed" && index === 5) ? (<div className='d-flex h-100 align-items-center'><span className='mr-2'>Completed</span><CompletedIcon /></div>) : cell.render( 'Cell' )} */}
                              </p>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            {isServerErrorOnList &&
              (isServerDataNotFoundErrorOnList ? (
                <div className="document-no-data text-center">
                  <CustomClientError
                    CustomClasses="p-0 m-0"
                    ErrorHeading="No Result Found!"
                    ErrorMessage="We could not find any reports for the selected filter(s). Use another filter(s) and try again."
                  />
                </div>
              ) : (
                <div className="document-no-data text-center">
                  <CustomClientError
                    ErrorHeading="Something went wrong with request!"
                    ErrorMessage="Please try again."
                  />
                </div>
              ))}
            <Row className="mt-4 mb-4 align-items-center">
              {reportsData?.pagination?.totalRecords > 10 && (
                <>
                  <Col sm={6}>
                    <CustomPaginationItemsDisplay
                      pageSize={reportsData?.pagination?.pageSize}
                      setPageSize={(e) => pageSizeHandler(Number(e?.value))}
                      prefixMessage="Records per page"
                      suffixMessage={showingRecordsMessage()}
                    />
                  </Col>
                  <Col sm={6} className="text-right mt-4 mt-md-0">
                    <div className="reports-table-pagination">
                      {reportsData?.pagination?.totalRecords > 10 ? (
                        <CustomPagination
                          pageSize={reportsData?.pagination?.pageSize}
                          currentPage={reportsData?.pagination?.pageNumber}
                          totalCount={reportsData?.pagination?.totalRecords}
                          onPageChange={(page) => {
                            paginationHandler(page);
                            //dispatch( setSearchParams( {pageNumber: page} ) );
                            //recordsFilterHandler( recordsToDisplay, pageSize, page );
                          }}
                        />
                      ) : null}
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </div>
        )}
      </div>
    </>
  );
};

export default ReportsListTable;
